/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect} from 'react';
import usePersistentStore from "../../persistentStore";
import {useQuery} from "@apollo/react-hooks";
import {GET_USER_PREFERENCES} from "../../database/queries/userPreferences";
import {tellParentMessage} from "../../utils/utils";
import {GET_CONTACT_BY_LINKEDIN_ID} from "../../database/queries/contactQueries";
import {GET_ACCOUNT_BY_LINKEDIN_ID} from "../../database/queries/accountQueries";

const PopupUserPreferences = props => {
    const [globalPersistentState] = usePersistentStore();

    const {data: getUserPreferencesData} = useQuery(GET_USER_PREFERENCES, {
        variables: {domain: 'popup'}
    });

    const {refetch: getAccountByLinkedinIdRefetch} = useQuery(GET_ACCOUNT_BY_LINKEDIN_ID, {skip: true});

    const {refetch: getContactByLinkedinIdRefetch} = useQuery(GET_CONTACT_BY_LINKEDIN_ID, {skip: true});

    useEffect(() => {
        if (globalPersistentState.popupQueryObj) {
            if (getUserPreferencesData && getUserPreferencesData.userPreferences && getUserPreferencesData.userPreferences.length > 0) {
                tellParentMessage({userPreferences: getUserPreferencesData.userPreferences ? getUserPreferencesData.userPreferences : 'not logged in'}, globalPersistentState.popupQueryObj)
            }

            if (globalPersistentState.popupQueryObj.selectionUrl) {
                const accountRegex = /linkedin\.com\/company\/([^/]+)/gi;
                const accountMatch = accountRegex.exec(globalPersistentState.popupQueryObj.selectionUrl);
                if (accountMatch) {
                    getAccountByLinkedinIdRefetch({accountLinkedinId: accountMatch[1]}).then(refetchResult => {
                        tellParentMessage(!refetchResult.data || !refetchResult.data.accountByLinkedinId ? {accountId: 'not found'} : {accountId: refetchResult.data.accountByLinkedinId.accountId}, globalPersistentState.popupQueryObj)
                    }).catch(e => {
                        console.trace(e);
                    });
                } else {
                    const contactRegex = /linkedin\.com\/in\/([^/]+)/gi;
                    const contactMatch = contactRegex.exec(globalPersistentState.popupQueryObj.selectionUrl);
                    if (contactMatch) {
                        getContactByLinkedinIdRefetch({contactLinkedinId: contactMatch[1]}).then(refetchResult => {
                            tellParentMessage(!refetchResult.data || !refetchResult.data.contactByLinkedinId ? {contactId: 'not found'} : {contactId: refetchResult.data.contactByLinkedinId.contactId}, globalPersistentState.popupQueryObj)
                        }).catch(e => {
                            console.trace(e);
                        });
                    }
                }
            }
        }
    }, [getUserPreferencesData]);

    return (
        <></>
    )
};

export default PopupUserPreferences
